/** Password strength rules (mirrors backend passwordPolicy.js). */
export function getPasswordChecks(pwd) {
  return [
    { id: "len", label: "At least 8 characters", pass: pwd.length >= 8 },
    { id: "letter", label: "At least one letter (a–z / A–Z)", pass: /[a-zA-Z]/.test(pwd) },
    { id: "num", label: "At least one number (0–9)", pass: /[0-9]/.test(pwd) },
    { id: "upper", label: "At least one uppercase letter", pass: /[A-Z]/.test(pwd) },
    { id: "spec", label: "At least one special character", pass: /[^a-zA-Z0-9]/.test(pwd) },
  ];
}

export function strengthScore(checks) {
  return checks.filter((c) => c.pass).length;
}

export const STRENGTH_META = [
  null,
  { label: "Very weak", bar: "w-1/5", color: "bg-red-500", text: "text-red-600" },
  { label: "Weak", bar: "w-2/5", color: "bg-orange-400", text: "text-orange-500" },
  { label: "Fair", bar: "w-3/5", color: "bg-yellow-400", text: "text-yellow-600" },
  { label: "Strong", bar: "w-4/5", color: "bg-emerald-400", text: "text-emerald-600" },
  { label: "Very strong", bar: "w-full", color: "bg-emerald-500", text: "text-emerald-700" },
];

export function passwordMeetsMinimum(checks) {
  const required = checks.filter((c) => ["len", "letter", "num"].includes(c.id));
  return required.every((c) => c.pass);
}
